<div class="container--padding">
  <h2 class="mt-5">{{ "Members" | translate }}</h2>
  <br />

  <div class="row">
    <div class="col-lg-7">
      <div class="new__member">
        <h3>{{ "General information" | translate }}</h3>
        <form>
          <div class="form-row">
            <div class="form-group col-lg-6">
              <input
                type="text"
                class="form-control"
                id="name"
                name="newEmail"
                placeholder="ACME Corp."
              />
            </div>
            <div class="form-group col-lg-4">
              <select class="form-control">
                <option>Owner</option>
                <option>Reviewer</option>
                <option>Member</option>
              </select>
            </div>
            <div class="form-group col-lg-2">
              <button
                type="button"
                class="button button--purple invite__button"
                [disabled]="false"
              >
                {{ "Invite" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <br />

      <div class="members">
        <div class="row">
          <div class="col-8">
            <h3>{{ "Email" | translate }}</h3>
          </div>
          <div class="col-4 padding-side--5">
            <h3>{{ "Role" | translate }}</h3>
          </div>
        </div>
        <form>
          <div class="form-row">
            <div class="form-group col-8">
              <input
                type="text"
                class="form-control"
                id="name"
                name="newEmail"
                placeholder="ACME Corp."
              />
            </div>
            <div class="form-group col-3">
              <select class="form-control">
                <option>Owner</option>
                <option>Reviewer</option>
                <option>Member</option>
              </select>
            </div>
            <div class="form-group col-1">
              <button class="close" aria-label="Close"></button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-lg-5">
      <div class="row flex-nowrap tips__container">
        <div class="col-1">
          <div class="vl"></div>
        </div>
        <div class="col-11">
          <h3 class="tips__title--text">{{ "Tips & Tricks" | translate }}</h3>
          <p class="tips--text">
            {{ "TipsAndTricksDesc" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
